import React, { useEffect } from 'react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

const GalleryTemplate = (props) => {
  const { galleryID, images } = props;

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: `#${galleryID}`,
      children: 'a',
      thumbSelector: 'a',
      pswpModule: () => import('photoswipe'),
    });

    // Image download function;
    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'download-button',
        order: 8,
        isButton: true,
        tagName: 'a',

        // SVG with outline
        html: {
          isCustomSVG: true,
          inner: '<path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" id="pswp__icn-download"/>',
          outlineID: 'pswp__icn-download',
        },

        // Or provide full svg:
        // html: '<svg
        // width="32"
        // height="32"
        // viewBox="0 0 32 32"
        // aria-hidden="true"
        // class="pswp__icn">
        //   <path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" />
        //   </svg>',

        // Or provide any other markup:
        // html: '<i class="fa-solid fa-download"></i>'

        onInit: (el, pswp) => {
          el.setAttribute('download', '');
          el.setAttribute('target', '_blank');
          el.setAttribute('rel', 'noopener');

          pswp.on('change', () => {
            el.href = pswp.currSlide.data.src;
          });
        },
      });
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  useEffect(() => {
    const gallery = document.querySelectorAll('.pswp-gallery a');

    if (gallery) {
      for (let i = 0; i <= gallery.length; i += 1) {
        if (gallery[i]) {
          const elem = gallery[i];
          const elemImg = elem.querySelector('img');
          if (elemImg.addEventListener) {
            elemImg.addEventListener('load', () => {
              elem.setAttribute('data-pswp-width', `${elemImg.naturalWidth}px`);
              elem.setAttribute('data-pswp-height', `${elemImg.naturalHeight}px`);
              elemImg.style.width = `${elemImg.naturalWidth}px`;
              elemImg.style.height = `${elemImg.naturalHeight}px`;
            });
          } else {
            // it's IE!
            elemImg.attachEvent('onload', () => {
              elem.setAttribute('data-pswp-width', `${elemImg.naturalWidth}px`);
              elem.setAttribute('data-pswp-height', `${elemImg.naturalHeight}px`);
              elemImg.style.width = `${elemImg.naturalWidth}px`;
              elemImg.style.height = `${elemImg.naturalHeight}px`;
            });
          }
        }
      }
    }
  });

  return (
    <div className="pswp-gallery" id={galleryID}>
      {images
        .filter((image) => image.type === 'original')
        .map((image) => (
          <a
            href={image.src}
            data-pswp-width={1024}
            data-pswp-height={680}
            key={`${galleryID}-${image.id}`}
            target="_blank"
            rel="noreferrer"
          >
            <img loading="lazy" src={image.src} alt="" />
          </a>
        ))}
    </div>
  );
};

export default GalleryTemplate;
